import { render, staticRenderFns } from "./ArticleLastUpdateCell.vue?vue&type=template&id=17537f48&"
import script from "./ArticleLastUpdateCell.vue?vue&type=script&lang=js&"
export * from "./ArticleLastUpdateCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports